import {CompetenceExperienceModel} from './competence-experience.model';

export class SearchRankingModel {
  constructor(public jobOrderContent: string,
              public cityDictIds: number[],
              public competenceExperiences: CompetenceExperienceModel[],
              public minSalary: number,
              public maxSalary: number,
              public remote: boolean) {
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ranking/search-ranking.model.ts